import {
    RESET_VARIABLE,
    GET_VARIABLE,
    SET_VARIABLE,
    API_ERROR_VARIABLE,
  } from "./actionTypes";
  
  export const resetVariables = () => {
    return {
      type: RESET_VARIABLE,
      payload: {},
    };
  };
  
  
  export const getVariables = (variables) => {
    return {
      type: GET_VARIABLE,
      payload: { variables },
    };
  };
  
  export const setVariables = (data) => {
  
    return {
      type: SET_VARIABLE,
      payload: {data},
    };
  };
  
  export const errorVariables = (error) => {
    return {
      type: API_ERROR_VARIABLE,
      payload: error,
    };
  };
  